











































import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { ZboziDruh } from '@/modules/ciselnik/skladove/zbozidruh';
import { listFactory } from '@/main/pages';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import { listMutations } from './store/types';
import { store } from './store/list';
import { NAME } from '../constants';

import { GRID_COLUMNS } from './constants';


export default listFactory(NAME, store).extend({
	data() {
		return {
			gridCols: GRID_COLUMNS,
		};
	},
	components: {
		ZboziDruhSelect: ZboziDruh.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${listMutations.ND_POHYB_DODAVATEL_FILTER_SELECT_MAPPER}`,
				zbozi: `${this.storeUri}/${listMutations.ND_POHYB_ZBOZI_FILTER_SELECT_MAPPER}`,
				nakladoveSterdisko: `${this.storeUri}/${listMutations.ND_POHYB_NAKLADOVE_STREDISKO_FILTER_SELECT_MAPPER}`,
				rabatSk: `${this.storeUri}/${listMutations.ND_POHYB_RABAT_SK_FILTER_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${listMutations.ND_POHYB_PRACOVNIK_FILTER_SELECT_MAPPER}`,
				zadavatel: `${this.storeUri}/${listMutations.ND_POHYB_ZADAVATEL_FILTER_SELECT_MAPPER}`,
			};
		},
		zboziDruhFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		rabatSkFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
	},
	methods: {
		OpenPartMaintenance,
	},
});
